/* DEPARTMENTS */
export const GET_MEETINGS = 'GET_MEETINGS';
export const GET_MEETINGS_SUCCESS = 'GET_MEETINGS_SUCCESS';
export const GET_MEETINGS_FAIL = 'GET_MEETINGS_FAIL';

export const ADD_MEETING = 'ADD_MEETING';
export const ADD_MEETING_SUCCESS = 'ADD_MEETING_SUCCESS';
export const ADD_MEETING_FAIL = 'ADD_MEETING_FAIL';

export const UPDATE_MEETING = 'UPDATE_MEETING';
export const UPDATE_MEETING_SUCCESS = 'UPDATE_MEETING_SUCCESS';
export const UPDATE_MEETING_FAIL = 'UPDATE_MEETING_FAIL';

export const DELETE_MEETING = 'DELETE_MEETING';
export const DELETE_MEETING_SUCCESS = 'DELETE_MEETING_SUCCESS';
export const DELETE_MEETING_FAIL = 'DELETE_MEETING_FAIL';

export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
